import $ from './jquery-3.2.1.min';
import publicFunctions from './public-functions'
import variables from './variables';

const inhibitors = {
    // This function sets and run the default animation for "Hemophilia A, Low Inhibitors" and show the treatments buttons for "Hemophilia A, Low Inhibitors" and hide the other ones
    runHemA_LowTiter: function runHemA_LowTiter() {
		// Lists of treatments buttons to hide
		const treatments_to_hide = ['btnTrmtAaRF', 'btnTrmtAHiAPCC', 'btnTrmtAHiFVIIIa', 'btnTrmtBaRF', 'btnTrmtBLoRF', 'btnTrmtBHiAPCC', 'btnTrmtBHiFVIIIa', 'btnTrmtvW', 'btnTrmtDesmopressin', 'btnTrmtvWFVIII'];
		// Lists of treatments buttons to show
		const treatments_to_show = ['btnTrmtALoRF'];
		
        publicFunctions.showAllGears();
		publicFunctions.resetTimelines();
		publicFunctions.resetConditionState();
		publicFunctions.defaultScaleDown();

        //Only get in if the button of the current timeline hasn't be clicked yet
        if (variables.counters.hemALowCounter <= 0) {
            //sets animation gears and factors for condition and inhibitor actions
            variables.hemALowTimeline.to(belt_full, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
            variables.hemALowTimeline.to(belt_broken, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
            variables.hemALowTimeline.to(factor_08_activated, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
			variables.hemALowTimeline.to(factor_12_div, .5, {scale: 1, delay: 0}, 0);
			variables.hemALowTimeline.to(factor_12, 4, {rotation: -1240, ease: Power0.easeNone, delay: 0.5}, 0);
			variables.hemALowTimeline.to(grey_gear_01, 4, {rotation: 1240, ease: Power0.easeNone, delay: 0.5}, 0);
			variables.hemALowTimeline.to(factor_11_div, .5, {scale: 1, delay: 1}, 0);
			variables.hemALowTimeline.to(factor_11, 3, {rotation: -880, ease: Power0.easeNone, delay: 1.5}, 0);
			variables.hemALowTimeline.to(small_gear_01, 3, {rotation: 880, ease: Power0.easeNone, delay: 1.5}, 0);
			variables.hemALowTimeline.to(factor_09_div, .5, {scale: 1, delay: 2}, 0);
			variables.hemALowTimeline.to(factor_09, 2, {rotation: -520, ease: Power0.easeNone, delay: 2.5}, 0);
            variables.hemALowTimeline.to(grey_gear_02, 2, {rotation: 520, ease: Power0.easeNone, delay: 2.5}, 0);
            variables.hemALowTimeline.to(factor_08_div, .5, {scale: 1, delay: 3}, 0);
            variables.hemALowTimeline.to(factor_08, .5, {fill: "#cbf3ee", delay: 3.5}, 0);
            variables.hemALowTimeline.to(factor_CLOT, .5, {fill: "#cbf3ee", delay: 3.5}, 0);
            variables.hemALowTimeline.to(belt_broken, .5, {autoAlpha: 1, display: 'block', delay: 3.5}, 0);
            variables.hemALowTimeline.to([factor_12,factor_11, factor_09], 100, {rotation: -36000, ease: Power0.easeNone, delay: 4.5, repeat:-1}, 0);
			variables.hemALowTimeline.to([grey_gear_01, small_gear_01, grey_gear_02], 100, {rotation: 36000, ease: Power0.easeNone, delay: 4.5, repeat:-1}, 0);
			
            // Increase the counter
            variables.counters.hemALowCounter++;
        }

       // This funtion hide the treatments buttons
        publicFunctions.hideElements(treatments_to_hide);
        // This funtion show the treatments buttons
        publicFunctions.showElements(treatments_to_show);
        TweenLite.to(variables.hemA_Low_image, 1, { autoAlpha: 1, display: 'block' });     
        // Start the animation setted before
        variables.hemALowTimeline.play();
    },

    // This function sets and run the default animation for "Hemophilia A, High Inhibitors" and show the treatments buttons for "Hemophilia A, High Inhibitors" and hide the other ones
    runHemA_HiTiter: function runHemA_HiTiter() {
		// Lists of treatments buttons to hide
		const treatments_to_hide = ['btnTrmtALoRF', 'btnTrmtAaRF', 'btnTrmtBaRF', 'btnTrmtBLoRF', 'btnTrmtBHiAPCC', 'btnTrmtBHiFVIIIa', 'btnTrmtvW', 'btnTrmtDesmopressin', 'btnTrmtvWFVIII'];
		// Lists of treatments buttons to show
		const treatments_to_show = ['btnTrmtAHiAPCC', 'btnTrmtAHiFVIIIa'];
        
        publicFunctions.showAllGears();
		publicFunctions.resetTimelines();	
		publicFunctions.resetConditionState();
		publicFunctions.defaultScaleDown();     

        //Only get in if the button of the current timeline hasn't be clicked yet
        if (variables.counters.hemAHighCounter <= 0) {
            //sets animation gears and factors for condition and inhibitor actions
            variables.hemAHighTimeline.to(belt_full, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
            variables.hemAHighTimeline.to(belt_broken, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
            variables.hemAHighTimeline.to(factor_08_activated, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
			variables.hemAHighTimeline.to(factor_12_div, .5, {scale: 1, delay: 0}, 0);
			variables.hemAHighTimeline.to(factor_12, 4, {rotation: -1240, ease: Power0.easeNone, delay: 0.5}, 0);
			variables.hemAHighTimeline.to(grey_gear_01, 4, {rotation: 1240, ease: Power0.easeNone, delay: 0.5}, 0);
			variables.hemAHighTimeline.to(factor_11_div, .5, {scale: 1, delay: 1}, 0);
			variables.hemAHighTimeline.to(factor_11, 3, {rotation: -880, ease: Power0.easeNone, delay: 1.5}, 0);
			variables.hemAHighTimeline.to(small_gear_01, 3, {rotation: 880, ease: Power0.easeNone, delay: 1.5}, 0);
			variables.hemAHighTimeline.to(factor_09_div, .5, {scale: 1, delay: 2}, 0);
			variables.hemAHighTimeline.to(factor_09, 2, {rotation: -520, ease: Power0.easeNone, delay: 2.5}, 0);
            variables.hemAHighTimeline.to(grey_gear_02, 2, {rotation: 520, ease: Power0.easeNone, delay: 2.5}, 0);
            variables.hemAHighTimeline.to(factor_08_div, .5, {scale: 1, delay: 3}, 0);
            variables.hemAHighTimeline.to(factor_08, .5, {fill: "#cbf3ee", delay: 3.5}, 0);
            variables.hemAHighTimeline.to(factor_CLOT, .5, {fill: "#cbf3ee", delay: 3.5}, 0);
            variables.hemAHighTimeline.to(belt_broken, .5, {autoAlpha: 1, display: 'block', delay: 3.5}, 0);
            variables.hemAHighTimeline.to([factor_12,factor_11, factor_09], 100, {rotation: -36000, ease: Power0.easeNone, delay: 4.5, repeat:-1}, 0);
			variables.hemAHighTimeline.to([grey_gear_01, small_gear_01, grey_gear_02], 100, {rotation: 36000, ease: Power0.easeNone, delay: 4.5, repeat:-1}, 0);
            // Increase the counter
            variables.counters.hemAHighCounter++;
        }

        // This funtion hide the treatments buttons
        publicFunctions.hideElements(treatments_to_hide);
        // This funtion show the treatments buttons
        publicFunctions.showElements(treatments_to_show);

        TweenLite.to(variables.hemA_High_image, 1, { autoAlpha: 1, display: 'block' });
        // Start the animation setted before
        variables.hemAHighTimeline.play();
    },

    // This function sets and run the default animation for "Hemophilia B, Low Inhibitors" and show the treatments buttons for "Hemophilia B, Low Inhibitors" and hide the other ones
    runHemB_LowTiter: function runHemB_LowTiter() {
		// Lists of treatments buttons to hide
		const treatments_to_hide = ['btnTrmtALoRF', 'btnTrmtAHiAPCC', 'btnTrmtAHiFVIIIa', 'btnTrmtBaRF', 'btnTrmtAaRF', 'btnTrmtBHiAPCC', 'btnTrmtBHiFVIIIa', 'btnTrmtvW', 'btnTrmtDesmopressin', 'btnTrmtvWFVIII'];
		// Lists of treatments buttons to show
		const treatments_to_show = ['btnTrmtBLoRF'];    
        
        publicFunctions.showAllGears();
		publicFunctions.resetTimelines();
		publicFunctions.resetConditionState();
		publicFunctions.defaultScaleDown();

        //Only get in if the button of the current timeline hasn't be clicked yet
        if (variables.counters.hemBLowCounter <= 0) {
            //sets animation gears and factors for condition and inhibitor actions
            variables.hemBLowTimeline.to(belt_full, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
            variables.hemBLowTimeline.to(belt_broken, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
            variables.hemBLowTimeline.to(factor_08_activated, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
			variables.hemBLowTimeline.to(factor_12_div, .5, {scale: 1, delay: 0}, 0);
			variables.hemBLowTimeline.to(factor_12, 4, {rotation: -1240, ease: Power0.easeNone, delay: 0.5}, 0);
			variables.hemBLowTimeline.to(grey_gear_01, 4, {rotation: 1240, ease: Power0.easeNone, delay: 0.5}, 0);
			variables.hemBLowTimeline.to(factor_11_div, .5, {scale: 1, delay: 1}, 0);
			variables.hemBLowTimeline.to(factor_11, 3, {rotation: -880, ease: Power0.easeNone, delay: 1.5}, 0);
			variables.hemBLowTimeline.to(small_gear_01, 3, {rotation: 880, ease: Power0.easeNone, delay: 1.5}, 0);
			variables.hemBLowTimeline.to(factor_09_div, .5, {scale: 1, delay: 2}, 0);
			variables.hemBLowTimeline.to(factor_09, .5, {fill: "#cbf3ee" , delay: 2.5}, 0);
            variables.hemBLowTimeline.to(factor_CLOT, .5, {fill: "#cbf3ee", delay: 2.5}, 0);
            variables.hemBLowTimeline.to(belt_broken, .5, {autoAlpha: 1, display: 'block', delay: 2.5}, 0);
            variables.hemBLowTimeline.to([factor_12,factor_11], 100, {rotation: -36000, ease: Power0.easeNone, delay: 4.5, repeat:-1}, 0);
			variables.hemBLowTimeline.to([grey_gear_01, small_gear_01], 100, {rotation: 36000, ease: Power0.easeNone, delay: 4.5, repeat:-1}, 0);
            // Increase the counter
            variables.counters.hemBLowCounter++;
        }

        // This funtion hide the treatments buttons
        publicFunctions.hideElements(treatments_to_hide);
        // This funtion show the treatments buttons
        publicFunctions.showElements(treatments_to_show);

        TweenLite.to(variables.hemB_Low_image, 1, { autoAlpha: 1, display: 'block' });
        // Start the animation setted before
        variables.hemBLowTimeline.play();
    },

    // This function sets and run the default animation for "Hemophilia B, High Inhibitors" and show the treatments buttons for "Hemophilia B, High Inhibitors" and hide the other ones
    runHemB_HiTiter: function runHemB_HiTiter() {
		// Lists of treatments buttons to hide
		const treatments_to_hide = ['btnTrmtALoRF', 'btnTrmtAHiAPCC', 'btnTrmtAHiFVIIIa', 'btnTrmtBaRF', 'btnTrmtBLoRF', 'btnTrmtAaRF', 'btnTrmtvW', 'btnTrmtDesmopressin', 'btnTrmtvWFVIII'];
		// Lists of treatments buttons to show
		const treatments_to_show = ['btnTrmtBHiAPCC', 'btnTrmtBHiFVIIIa'];

        publicFunctions.showAllGears();
		publicFunctions.resetTimelines();
		publicFunctions.resetConditionState();
		publicFunctions.defaultScaleDown();

        //Only get in if the button of the current timeline hasn't be clicked yet
        if (variables.counters.hemBHighCounter <= 0) {
            //sets animation gears and factors for condition and inhibitor actions
            variables.hemBHighTimeline.to(belt_full, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
            variables.hemBHighTimeline.to(belt_broken, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
            variables.hemBHighTimeline.to(factor_08_activated, 0, {autoAlpha: 0, display: 'none', delay:0}, 0);
			variables.hemBHighTimeline.to(factor_12_div, .5, {scale: 1, delay: 0}, 0);
			variables.hemBHighTimeline.to(factor_12, 4, {rotation: -1240, ease: Power0.easeNone, delay: 0.5}, 0);
			variables.hemBHighTimeline.to(grey_gear_01, 4, {rotation: 1240, ease: Power0.easeNone, delay: 0.5}, 0);
			variables.hemBHighTimeline.to(factor_11_div, .5, {scale: 1, delay: 1}, 0);
			variables.hemBHighTimeline.to(factor_11, 3, {rotation: -880, ease: Power0.easeNone, delay: 1.5}, 0);
			variables.hemBHighTimeline.to(small_gear_01, 3, {rotation: 880, ease: Power0.easeNone, delay: 1.5}, 0);
			variables.hemBHighTimeline.to(factor_09_div, .5, {scale: 1, delay: 2}, 0);
			variables.hemBHighTimeline.to(factor_09, .5, {fill: "#cbf3ee", delay: 2.5}, 0);
            variables.hemBHighTimeline.to(factor_CLOT, .5, {fill: "#cbf3ee", delay: 2.5}, 0);
            variables.hemBHighTimeline.to(belt_broken, .5, {autoAlpha: 1, display: 'block', delay: 2.5}, 0);
            variables.hemBHighTimeline.to([factor_12,factor_11], 100, {rotation: -36000, ease: Power0.easeNone, delay: 4.5, repeat:-1}, 0);
			variables.hemBHighTimeline.to([grey_gear_01, small_gear_01], 100, {rotation: 36000, ease: Power0.easeNone, delay: 4.5, repeat:-1}, 0);
            // Increase the counter
            variables.counters.hemBHighCounter++;
        }

        // This funtion hide the treatments buttons
        publicFunctions.hideElements(treatments_to_hide);
        // This funtion show the treatments buttons
        publicFunctions.showElements(treatments_to_show);

        TweenLite.to(variables.hemB_High_image, 1, { autoAlpha: 1, display: 'block' });
        // Start the animation setted before
        variables.hemBHighTimeline.play();
    }
}

export default inhibitors;


// WEBPACK FOOTER //
// ./src/js/inhibitors.js